'use client'
"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    default: ()=>Menu_Menu
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_react_namespaceObject = require("react");
const external_Menu_variants_cjs_namespaceObject = require("./Menu.variants.cjs");
const external_withSVGAttributes_cjs_namespaceObject = require("../withSVGAttributes.cjs");
const strokeProps = {
    stroke: '#001833',
    strokeLinecap: 'round',
    strokeMiterlimit: '10',
    strokeWidth: '2'
};
const topPathProps = {
    ...strokeProps,
    d: 'M4 7h16'
};
const middlePathProps = {
    ...strokeProps,
    d: 'M4 12h16'
};
const bottomPathProps = {
    ...strokeProps,
    d: 'M4 17h16'
};
const BaseMenuSVG = /*#__PURE__*/ (0, external_react_namespaceObject.forwardRef)(({ isOpen = false, size = 24, ...props }, ref)=>{
    const { top, middle, bottom } = (0, external_Menu_variants_cjs_namespaceObject.menuVariants)({
        ...props,
        isOpen
    });
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("svg", {
        ref: ref,
        height: size,
        width: size,
        ...props,
        "data-testid": "menu-svg",
        "data-state": isOpen ? 'open' : 'closed',
        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("g", {
            children: [
                /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("path", {
                    ...topPathProps,
                    className: top()
                }),
                /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("path", {
                    ...middlePathProps,
                    className: middle()
                }),
                /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("path", {
                    ...bottomPathProps,
                    className: bottom()
                })
            ]
        })
    });
});
BaseMenuSVG.displayName = 'BaseMenuSVG';
const Menu = (0, external_withSVGAttributes_cjs_namespaceObject.withSVGAttributes)(BaseMenuSVG);
const Menu_Menu = Menu;
exports["default"] = __webpack_exports__["default"];
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "default"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
